import { LegalLayout, Section, SubHead, Bullets } from '../components/LegalLayout';
import { BRAND } from '../lib/constants';

export default function RefundPolicy() {
  return (
    <LegalLayout
      title={<>Refund &amp; <span className="italic text-[#a465a8]">Cancellation</span>.</>}
      effective="01 February 2026"
      testId="refund-policy-page"
      intro={<>At Find Your MUA, we aim to create a seamless and transparent booking experience. Please read our cancellation and refund terms carefully.</>}
    >
      <Section n="01" title="Payment Structure">
        <p>Booking payments are structured as follows:</p>
        <SubHead>10% Booking Fee</SubHead>
        <p>Paid at booking confirmation through the Platform.</p>
        <SubHead>40% Payment</SubHead>
        <p>Payable within <strong>30 days of booking confirmation</strong>.</p>
        <SubHead>50% Final Payment</SubHead>
        <p>Payable on the <strong>day of the event</strong>.</p>
      </Section>

      <Section n="02" title="Party Makeup Cancellation Policy">
        <SubHead>Free Cancellation</SubHead>
        <p>Clients may cancel <strong>party makeup bookings free of charge before 30 days of the event date</strong>.</p>
        <SubHead>Cancellation Within 30 Days</SubHead>
        <p>No refund shall be provided on booking amounts for cancellations made <strong>within 30 days of the event</strong>.</p>
      </Section>

      <Section n="03" title="Bridal Makeup Cancellation Policy">
        <SubHead>Free Cancellation</SubHead>
        <p>Clients may cancel <strong>within 30 days of booking confirmation</strong> and receive a <strong>full refund of booking amount paid</strong>.</p>
        <SubHead>Cancellation After 30 Days of Booking</SubHead>
        <p>No refund shall be provided after <strong>30 days from booking confirmation</strong>, regardless of event date.</p>
      </Section>

      <Section n="04" title="Non-Refundable Situations">
        <p>Refunds shall not apply in cases including but not limited to:</p>
        <Bullets items={[
          'Change of mind',
          'Schedule conflicts',
          'Dissatisfaction after service completion',
          'Failure to communicate',
          'Delayed arrival by client',
          'Personal emergencies',
          'Venue changes',
        ]} />
      </Section>

      <Section n="05" title="Artist Cancellation">
        <p>In case an artist cancels unexpectedly, Find Your MUA will make reasonable efforts to arrange a replacement artist. If replacement is not possible, eligible payments made through the Platform may be refunded.</p>
      </Section>

      <Section n="06" title="Refund Timeline">
        <p>Approved refunds will typically be processed within <strong>7–14 business days</strong> through the original payment method.</p>
      </Section>

      <Section n="07" title="Force Majeure">
        <p>Refunds may not apply for disruptions caused by circumstances beyond reasonable control including:</p>
        <Bullets items={['Natural disasters', 'Government restrictions', 'Pandemic restrictions', 'Political unrest', 'Severe weather events']} />
      </Section>

      <Section n="08" title="Contact">
        <p>For cancellation or refund support:</p>
        <p><strong>Find Your MUA</strong><br />Email: <a href={`mailto:${BRAND.email}`} className="text-[#eb5381] underline">{BRAND.email}</a></p>
      </Section>
    </LegalLayout>
  );
}
